// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const links = [
//   { label: 'Home',    path: '/' },
//   { label: 'Menu',    path: '/menu' },
//   { label: 'About',   path: '/about' },
//   { label: 'Gallery', path: '/gallery' },
//   { label: 'Contact', path: '/contact' },
// ];

// export default function Navbar() {
//   const [scrolled, setScrolled] = useState(false);
//   const [open,     setOpen]     = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const fn = () => setScrolled(window.scrollY > 60);
//     window.addEventListener('scroll', fn);
//     return () => window.removeEventListener('scroll', fn);
//   }, []);

//   useEffect(() => { setOpen(false); }, [location]);

//   return (
//     <>
//       <motion.nav
//         initial={{ y: -80, opacity: 0 }}
//         animate={{ y: 0,   opacity: 1 }}
//         transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
//         style={{
//           position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
//           padding: scrolled ? '10px 0' : '20px 0',
//           background: scrolled ? 'rgba(250,243,232,0.97)' : 'linear-gradient(180deg, rgba(250,243,232,0.92) 0%, rgba(250,243,232,0) 100%)',
//           backdropFilter: scrolled ? 'blur(16px) saturate(1.5)' : 'none',
//           borderBottom: scrolled ? '1px solid rgba(124,43,14,0.12)' : 'none',
//           transition: 'all 0.5s cubic-bezier(0.22,1,0.36,1)',
//           boxShadow: scrolled ? '0 2px 24px rgba(124,43,14,0.08)' : 'none',
//         }}
//       >
//         <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

//           {/* Logo */}
//           <Link to="/" style={{ textDecoration: 'none' }}>
//             <motion.img
//               src="/logo.png"
//               alt="Karali Jaipur"
//               style={{ height: scrolled ? 44 : 56, transition: 'height 0.4s ease', filter: 'drop-shadow(0 2px 8px rgba(124,43,14,0.2))' }}
//               whileHover={{ scale: 1.05 }}
//               transition={{ type: 'spring', stiffness: 300 }}
//             />
//           </Link>

//           {/* Desktop links */}
//           <div className="hide-m" style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
//             {links.map(link => {
//               const active = location.pathname === link.path;
//               return (
//                 <Link key={link.path} to={link.path} style={{
//                   fontFamily: 'var(--font-title)', fontSize: '0.65rem', letterSpacing: '0.25em',
//                   textTransform: 'uppercase', textDecoration: 'none',
//                   color: active ? 'var(--tiger)' : 'var(--ink-mid)',
//                   position: 'relative', paddingBottom: 4,
//                   transition: 'color 0.3s',
//                 }}
//                   onMouseEnter={e => e.currentTarget.style.color = 'var(--tiger)'}
//                   onMouseLeave={e => e.currentTarget.style.color = active ? 'var(--tiger)' : 'var(--ink-mid)'}
//                 >
//                   {link.label}
//                   {active && (
//                     <motion.span layoutId="nav-ul" style={{
//                       position: 'absolute', bottom: 0, left: 0, right: 0,
//                       height: 1.5, background: 'var(--tiger)',
//                       boxShadow: '0 0 8px rgba(124,43,14,0.5)',
//                     }} />
//                   )}
//                 </Link>
//               );
//             })}
//           </div>

//           <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
//             <Link to="/reservation" className="btn-primary hide-m" style={{ padding: '10px 24px', fontSize: '0.62rem' }}>
//               Reserve Table
//             </Link>

//             {/* Hamburger */}
//             <button onClick={() => setOpen(!open)} className="ham-btn"
//               style={{ background: 'none', border: 'none', cursor: 'none', padding: 6, display: 'none', flexDirection: 'column', gap: 5 }}
//             >
//               <motion.div animate={{ rotate: open ? 45 : 0, y: open ? 7 : 0 }} style={{ width: 24, height: 1.5, background: 'var(--tiger)', transformOrigin: 'center' }} />
//               <motion.div animate={{ opacity: open ? 0 : 1 }} style={{ width: 18, height: 1.5, background: 'var(--tiger)' }} />
//               <motion.div animate={{ rotate: open ? -45 : 0, y: open ? -7 : 0 }} style={{ width: 24, height: 1.5, background: 'var(--tiger)', transformOrigin: 'center' }} />
//             </button>
//           </div>
//         </div>
//       </motion.nav>

//       {/* Mobile menu */}
//       <AnimatePresence>
//         {open && (
//           <motion.div
//             initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
//             transition={{ duration: 0.5, ease: [0.76,0,0.24,1] }}
//             style={{
//               position: 'fixed', inset: 0, zIndex: 999,
//               background: 'var(--cream)',
//               display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
//             }}
//           >
//             {/* Tiger watermark */}
//             <img src="/logo.png" alt="" style={{ position: 'absolute', width: '80%', opacity: 0.06, pointerEvents: 'none' }} />
//             {links.map((l,i) => (
//               <motion.div key={l.path}
//                 initial={{ opacity:0, x:40 }} animate={{ opacity:1, x:0 }} exit={{ opacity:0, x:40 }}
//                 transition={{ delay: i*0.07, duration: 0.4 }}
//               >
//                 <Link to={l.path} style={{
//                   display: 'block', fontFamily: 'var(--font-title)', fontSize: 'clamp(1.5rem,5vw,2.3rem)',
//                   letterSpacing: '0.25em', color: location.pathname===l.path ? 'var(--tiger)' : 'var(--ink)',
//                   textDecoration: 'none', padding: '12px 0', textAlign: 'center',
//                 }}>{l.label}</Link>
//               </motion.div>
//             ))}
//             <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.45 }} style={{ marginTop: 32 }}>
//               <Link to="/reservation" className="btn-primary">Reserve a Table</Link>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <style>{`@media(max-width:900px){.ham-btn{display:flex!important;}.hide-m{display:none!important;}}@media(max-width:480px){nav>div{padding:0 20px!important;}}`}</style>
//     </>
//   );
// }
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const links = [
  { label: 'Home',    path: '/' },
  { label: 'Menu',    path: '/menu' },
  { label: 'About',   path: '/about' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <>
      <motion.nav
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0,   opacity: 1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
          padding: scrolled ? '10px 0' : '20px 0',
          background: scrolled ? 'rgba(250,243,232,0.97)' : 'linear-gradient(180deg, rgba(250,243,232,0.92) 0%, rgba(250,243,232,0) 100%)',
          backdropFilter: scrolled ? 'blur(16px) saturate(1.5)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(124,43,14,0.12)' : 'none',
          transition: 'all 0.5s cubic-bezier(0.22,1,0.36,1)',
          boxShadow: scrolled ? '0 2px 24px rgba(124,43,14,0.08)' : 'none',
        }}
      >
        <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <motion.img
              src="/logo1.png"
              alt="Karali Jaipur"
              style={{
                height: scrolled ? 70 : 120,   // 🔥 Bigger logo
                transition: 'all 0.4s ease',
                background: 'transparent',    // remove bg
                mixBlendMode: 'multiply',     // 🔥 removes white bg visually
                objectFit: 'contain',
                filter: 'drop-shadow(0 4px 20px rgba(212,175,55,0.3))'
              }}
              whileHover={{ scale: 1.08 }}
              transition={{ type: 'spring', stiffness: 300 }}
            />
          </Link>

          {/* Desktop links */}
          <div className="hide-m" style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
            {links.map(link => {
              const active = location.pathname === link.path;
              return (
                <Link key={link.path} to={link.path} style={{
                  fontFamily: 'var(--font-title)', fontSize: '0.95rem', letterSpacing: '0.25em',
                  textTransform: 'uppercase', textDecoration: 'none',
                  color: active ? 'var(--tiger)' : 'var(--ink-mid)',
                  position: 'relative', paddingBottom: 4,
                  transition: 'color 0.3s',
                }}
                  onMouseEnter={e => e.currentTarget.style.color = 'var(--tiger)'}
                  onMouseLeave={e => e.currentTarget.style.color = active ? 'var(--tiger)' : 'var(--ink-mid)'}
                >
                  {link.label}
                  {active && (
                    <motion.span layoutId="nav-ul" style={{
                      position: 'absolute', bottom: 0, left: 0, right: 0,
                      height: 1.5, background: 'var(--tiger)',
                      boxShadow: '0 0 8px rgba(124,43,14,0.5)',
                    }} />
                  )}
                </Link>
              );
            })}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Link to="/reservation" className="btn-primary hide-m" style={{ padding: '10px 24px', fontSize: '0.62rem' }}>
              Reserve Table
            </Link>

            {/* Hamburger */}
            <button onClick={() => setOpen(!open)} className="ham-btn"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, display: 'none', flexDirection: 'column', gap: 5 }}
            >
              <motion.div animate={{ rotate: open ? 45 : 0, y: open ? 7 : 0 }} style={{ width: 24, height: 1.5, background: 'var(--tiger)', transformOrigin: 'center' }} />
              <motion.div animate={{ opacity: open ? 0 : 1 }} style={{ width: 18, height: 1.5, background: 'var(--tiger)' }} />
              <motion.div animate={{ rotate: open ? -45 : 0, y: open ? -7 : 0 }} style={{ width: 24, height: 1.5, background: 'var(--tiger)', transformOrigin: 'center' }} />
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
            transition={{ duration: 0.5, ease: [0.76,0,0.24,1] }}
            style={{
              position: 'fixed', inset: 0, zIndex: 999,
              background: 'var(--cream)',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}
          >
            <img src="/logo.png" alt="" style={{ position: 'absolute', width: '80%', opacity: 0.06, pointerEvents: 'none' }} />
            {links.map((l,i) => (
              <motion.div key={l.path}
                initial={{ opacity:0, x:40 }} animate={{ opacity:1, x:0 }} exit={{ opacity:0, x:40 }}
                transition={{ delay: i*0.07, duration: 0.4 }}
              >
                <Link to={l.path} style={{
                  display: 'block', fontFamily: 'var(--font-title)', fontSize: 'clamp(1.5rem,5vw,2.3rem)',
                  letterSpacing: '0.25em', color: location.pathname===l.path ? 'var(--tiger)' : 'var(--ink)',
                  textDecoration: 'none', padding: '12px 0', textAlign: 'center',
                }}>{l.label}</Link>
              </motion.div>
            ))}
            <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.45 }} style={{ marginTop: 32 }}>
              <Link to="/reservation" className="btn-primary">Reserve a Table</Link>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media(max-width:900px){
          .ham-btn{display:flex!important;}
          .hide-m{display:none!important;}
        }
        @media(max-width:480px){
          nav>div{padding:0 20px!important;}
        }
      `}</style>
    </>
  );
}